/* eslint-disable */
import React, { Component } from 'react'


import Svg, {
    Circle,
    Ellipse,
    G,
    LinearGradient,
    RadialGradient,
    Line,
    Path,
    Polygon,
    Polyline,
    Rect,
    Symbol,

    Use,
    Defs,
    Stop
} from 'react-native-svg';
export const SvgExplora = ({ size }) => {
    return (<Svg
        viewBox="0 0 30 30"
        height={size}
        width={size}
    >
        <G fill="none" fillRule="evenodd" transform="translate(1 1)">
            <Circle cx="14" cy="14" r="14" stroke="#FFFFFF" />
            <G transform="translate(7 7)">
                <Circle cx="5" cy="5" r="5" stroke="#FFFFFF" />
                <Rect width="7.688" height="1" x="7.228" y="10.572" fill="#FFFFFF" transform="rotate(45 11.072 11.072)" rx=".5" />
            </G>
        </G>
    </Svg>)
}

